/* Warp-thread scroll rail for the Our Process page.
   Fills a fixed hairline with a gold weft as the reader moves through the
   chapters, setting a knot at each .pch chapter passed. Fixed element + JS
   (not sticky). Measures live DOM offsets, so lazy media/resizes recompute. */
(function () {
  'use strict';

  var rail = document.querySelector('[data-jthread]');
  if (!rail) return;

  var fill = rail.querySelector('.jthread__fill');
  var track = rail.querySelector('.jthread__track');
  var chapters = Array.prototype.slice.call(document.querySelectorAll('.pch'));
  if (!fill || !track || chapters.length < 2) return;

  var regionStart = 0;
  var regionEnd = 1;
  var knots = [];
  var ticking = false;
  var shyZones = [];

  function docTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function measure() {
    // Position the thread in whatever left gutter the layout leaves: centered
    // in a generous margin on wide screens, hugging the edge like a selvage
    // when the container runs nearly full-bleed (typical laptops).
    var inner = document.querySelector('.pch__inner');
    var gutter = inner ? inner.getBoundingClientRect().left : 0;
    rail.style.left = (gutter >= 60 ? Math.max(4, Math.round(gutter / 2) - 4) : 4) + 'px';

    // Full-bleed artwork the thread should never draw over.
    shyZones = [];
    var shyEls = document.querySelectorAll('.banner-section--full, .pch--bleed .pch__media, .priver__band');
    Array.prototype.forEach.call(shyEls, function (el) {
      var top = docTop(el);
      shyZones.push([top, top + el.offsetHeight]);
    });

    var first = chapters[0];
    var last = chapters[chapters.length - 1];
    regionStart = docTop(first);
    regionEnd = docTop(last) + last.offsetHeight;
    if (regionEnd - regionStart < 1) regionEnd = regionStart + 1;

    if (!knots.length) {
      chapters.forEach(function () {
        var k = document.createElement('span');
        k.className = 'jthread__knot';
        track.appendChild(k);
        knots.push(k);
      });
    }
    chapters.forEach(function (ch, i) {
      var center = docTop(ch) + ch.offsetHeight / 2;
      var pct = (center - regionStart) / (regionEnd - regionStart);
      knots[i].style.top = (Math.min(Math.max(pct, 0), 1) * 100) + '%';
      knots[i].dataset.pct = pct;
    });
  }

  function update() {
    ticking = false;
    var probe = window.pageYOffset + window.innerHeight * 0.55;
    var progress = (probe - regionStart) / (regionEnd - regionStart);
    var clamped = Math.min(Math.max(progress, 0), 1);
    fill.style.height = (clamped * 100) + '%';

    // The rail occupies the 21%–79% band of the viewport; fade it while any
    // full-bleed artwork crosses that band.
    var railTop = window.pageYOffset + window.innerHeight * 0.21;
    var railBottom = window.pageYOffset + window.innerHeight * 0.79;
    var shy = shyZones.some(function (z) {
      return z[0] < railBottom && z[1] > railTop;
    });

    rail.classList.toggle('is-visible', !shy && progress > 0.005 && progress < 1.02);
    knots.forEach(function (k) {
      k.classList.toggle('is-set', clamped >= parseFloat(k.dataset.pct || '1'));
    });
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function remeasure() {
    measure();
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', remeasure);
  window.addEventListener('load', remeasure);
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(remeasure);
    ro.observe(document.body);
  }
  remeasure();
})();
